import { css } from "@emotion/react";

export const subtitle = css`
  text-align: center;
  margin-bottom: 0.5rem;
  max-width: 30rem;
`;
